import { BrandingData } from './types';

export const selectBranding = (state: any): BrandingData => state.account?.info?.branding;

export const selectInfo = (state: any) => state.account?.info;
